// src/components/UserLink.js
// Nom d'utilisateur cliquable menant vers son profil public (/profile/:id).
// Si aucun id n'est fourni, rend le nom en texte simple (non cliquable) → jamais de lien cassé.
// stopPropagation par défaut pour ne pas déclencher le clic d'une ligne/carte parente.
import React from "react";
import { Link } from "react-router-dom";

export default function UserLink({
    id,
    firstName,
    lastName,
    fallback = "",
    className = "",
    style,
    stopPropagation = true,
}) {
    const name = [firstName, lastName].filter(Boolean).join(" ").trim() || fallback;
    if (!id) return <>{name}</>;
    return (
        <Link
            to={`/profile/${id}`}
            className={`user-link${className ? " " + className : ""}`}
            style={style}
            onClick={stopPropagation ? (e) => e.stopPropagation() : undefined}
        >
            {name}
        </Link>
    );
}
